export const formatDateForApi = (dateObj) => {
  const year = dateObj.getFullYear();
  const month =
    dateObj.getMonth() + 1 < 10
      ? '0' + (dateObj.getMonth() + 1)
      : dateObj.getMonth() + 1;
  const day =
    dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate();
  const hour =
    dateObj.getHours() < 10 ? '0' + dateObj.getHours() : dateObj.getHours();
  const minutes =
    dateObj.getMinutes() < 10
      ? '0' + dateObj.getMinutes()
      : dateObj.getMinutes();
  const seconds =
    dateObj.getSeconds() < 10
      ? '0' + dateObj.getSeconds()
      : dateObj.getSeconds();

  return `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;
};

export const getMonthFromDate = (date) => {
  const monthNumber = date.slice(3, 5);
  switch (monthNumber) {
    case '01':
      return 'JAN';
    case '02':
      return 'FEB';
    case '03':
      return 'MAR';
    case '04':
      return 'APR';
    case '05':
      return 'MAJ';
    case '06':
      return 'JUN';
    case '07':
      return 'JUL';
    case '08':
      return 'AUG';
    case '09':
      return 'SEP';
    case '10':
      return 'OKT';
    case '11':
      return 'NOV';
    case '12':
      return 'DEC';
    default:
      return '';
  }
};

export const formatDateForRender = (dateString) => {
  let dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month =
    dateObj.getMonth() + 1 < 10
      ? '0' + (dateObj.getMonth() + 1)
      : dateObj.getMonth() + 1;
  const day =
    dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate();

  return day + '-' + month + '-' + year;
};

export const formatDateWithTimestampForRender = (dateString) => {
  let dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month =
    dateObj.getMonth() + 1 < 10
      ? '0' + (dateObj.getMonth() + 1)
      : dateObj.getMonth() + 1;
  const day =
    dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate();

  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

// Formats the DateTime object from DB to dd-mm-yyyy
export const formatDate = (dateString) => {
  let dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month =
    dateObj.getMonth() + 1 < 10
      ? '0' + (dateObj.getMonth() + 1)
      : dateObj.getMonth() + 1;
  const day =
    dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate();

  return day + '-' + month + '-' + year;
};

// Helper function for comparing dates
export const compareDates = (date1, date2) => {
  // checking year
  let y1 = parseInt(date1.slice(6, 10));
  let y2 = parseInt(date2.slice(6, 10));

  if (isNaN(y1) && !isNaN(y2)) {
    return -1;
  }
  if (!isNaN(y1) && isNaN(y2)) {
    return 1;
  }
  if (isNaN(y1) && isNaN(y2)) {
    return 0;
  }

  if (y1 > y2) {
    return 1;
  } else if (y1 < y2) {
    return -1;
  }

  // checking month
  let m1 = parseInt(date1.slice(3, 5));
  let m2 = parseInt(date2.slice(3, 5));

  if (m1 > m2) {
    return 1;
  } else if (m1 < m2) {
    return -1;
  }

  // checking day
  let d1 = parseInt(date1.slice(0, 2));
  let d2 = parseInt(date2.slice(0, 2));

  if (d1 > d2) {
    return 1;
  } else if (d1 < d2) {
    return -1;
  }

  // return 0 when dates are equal
  return 0;
};
